import { Injectable } from '@angular/core';
import { EncriptDecriptService } from './encriptdecript';

@Injectable()
export class UserAuthService {
  public userDetail: any;
  // store the URL so we can redirect after logging in
  redirectUrl: string;
  userObj:any;
  constructor(private encriptDecript:EncriptDecriptService) { 
    this.userObj=this.encriptDecript.getLocalStorage('userObject');
    if(this.userObj!=undefined&& this.userObj!=null){
      this.userDetail=JSON.parse(this.userObj);
    }
    else{
      this.isAuthenticated();
    }
  }

  public isAuthenticated(): boolean {
    this.userDetail ? this.userDetail : this.userDetail = undefined;
    if (this.userDetail) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/services/user-auth.service.ts